<template>
  <div class="radio-input-wrapper">
    <label v-if="label" class="radio-label">{{ label }}</label>
    <v-radio-group
      :name="name"
      v-model="localValue"
      @change="inputCallback"
      row
      dense
    >
      <v-radio
        v-for="(optionLabel, optionValue) in normalizedOptions"
        :key="optionValue"
        :label="optionLabel"
        :value="optionValue"
      />
    </v-radio-group>
  </div>
</template>
<script>
export default {
  name: "RadioInputComponent",
  props: {
    name:{
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true,
    },
    options: {
      required: true,
    },
    validation: {
      required: true,
    },
    value: {
      required: false
    }
  },

  data() {
    return {
      localValue: this.value
    }
  },

  computed: {
    normalizedOptions() {
      if (!this.options) return {}
      
      // Se já é objeto, retorna
      if (!Array.isArray(this.options)) {
        return this.options
      }
      
      // Se é array, converte para objeto
      return this.options.reduce((acc, valor, index) => {
        acc[`${index}`] = valor;
        return acc;
      }, {});
    }
  },

  watch: {
    value(newVal) {
      this.localValue = newVal
    }
  },

  methods: {
    inputCallback(value){
      this.$emit('input', value)
      this.$emit('update', value)
      this.$emit('validation', { hasErrors: false })
    }
  }
};
</script>

<style scoped>
.radio-input-wrapper {
  margin-bottom: 16px;
}

.radio-label {
  display: block;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  margin-bottom: 8px;
}
</style>